import { type JSX } from 'react';

import { createFileRoute } from '@tanstack/react-router';

import { LearningPathFormPage } from '@/features/learning-path/pages/LearningPathFormPage';
import { requireAccess } from '@/permissions';

export const Route = createFileRoute('/trilha-de-aprendizagem/editar/$id')({
  staticData: { title: 'Editar trilha de aprendizagem' },
  beforeLoad: requireAccess('view:learning_path'),
  component: EditarLearningPathRoute,
});

function EditarLearningPathRoute(): JSX.Element {
  const { id } = Route.useParams();
  const learningPathId = Number(id);

  if (!Number.isInteger(learningPathId) || learningPathId <= 0) {
    throw new Error('Invalid learning path id');
  }

  return (
    <LearningPathFormPage
      mode='edit'
      learningPathId={learningPathId}
    />
  );
}
